import React from "react";
import styled from "styled-components";

//
import REVIEWERLIST from "../../../assets/data/review-list";
import ReviewCard from "../../../components/review-card/ReviewCard";

export default function ReviewList() {
  return (
    <StyledReviewList>
      <div className="container">
        <div className="review-list__wrap">
          <ul>
            {REVIEWERLIST.map((i) => (
              <li key={i.id}>
                <ReviewCard
                  name={i.name}
                  title={i.title}
                  text={i.text}
                  img={i.img}
                  reviewPlace={i.reviewPlace}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </StyledReviewList>
  );
}

const StyledReviewList = styled.section`
  padding: 140px 0;

  .review-list {
    &__wrap {
      ul {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 32px;
      }
    }
  }
`;
